import DateAndOrTimePicker from '@/Controls/DateAndOrTimePickerBase';
import ComponentManager from '@/Management/ComponentManager';
import TimePickerViewModelType from '@/ViewModels/Controls/TimePickerViewModel';

export default class TimePicker extends DateAndOrTimePicker {
    public constructor(protected viewModel: TimePickerViewModelType, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null)
            return this.jQueryControl;

        this.jQueryControl = this.createControl(this.element, 'time', 'k-textbox');

        this.widget(null);

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'timepicker',
        });

        super.onWidgetCreatedCallback(widget);

        this.applyBindings(this.jQueryControl.find('input'), {
            attr: {
                min: this.viewModel.min,
                max: this.viewModel.max,
            }
        });
    }
}

ComponentManager.setControl('TimePicker', TimePicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');